import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useEventBus } from "@vueuse/core";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useConfig } from "@/composables/config";
import { useToolStore } from "@/stores/toolStore";
import ariaAlert from "@/utils/ariaAlert";
import Tool from "./Tool.vue";
import ToolPanelLabel from "./ToolPanelLabel.vue";
import ToolPanelLinks from "./ToolPanelLinks.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolSection',
    props: {
        category: null,
        queryFilter: { default: "" },
        disableFilter: { type: Boolean, default: false },
        hideName: { type: Boolean, default: false },
        operationTitle: { default: "" },
        operationIcon: { default: "" },
        toolKey: { default: "" },
        sectionName: { default: "default" },
        expanded: { type: Boolean, default: false },
        sortItems: { type: Boolean, default: true },
        hasFilterButton: { type: Boolean, default: false }
    },
    emits: ["onClick", "onFilter", "onOperation"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faFilter);
        const eventBus = useEventBus("open-tool-section");
        const { config, isConfigLoaded } = useConfig();
        const toolStore = useToolStore();
        const elems = computed(() => {
            if (toolSection.value.elems !== undefined && toolSection.value.elems.length > 0) {
                return toolSection.value.elems;
            }
            if (toolSection.value.tools !== undefined && toolSection.value.tools.length > 0) {
                return toolSection.value.tools.map((toolId) => {
                    const tool = toolStore.getToolForId(toolId);
                    if (!tool && typeof toolId !== "string") {
                        return toolId;
                    }
                    else {
                        return tool;
                    }
                });
            }
            return [];
        });
        const toolSection = computed(() => props.category);
        const toolSectionLabel = computed(() => props.category);
        const name = computed(() => toolSection.value.title || toolSection.value.name);
        const isSection = computed(() => toolSection.value.tools !== undefined || toolSection.value.elems !== undefined);
        const hasElements = computed(() => elems.value.length > 0);
        const title = computed(() => props.category.description || undefined);
        const links = computed(() => toolSection.value.links || {});
        const opened = ref(props.expanded || checkFilter());
        const sortedElements = computed(() => {
            // If this.config.sortTools is true, sort the tools alphabetically
            // When administrators have manually inserted labels we respect
            // the order set and hope for the best from the integrated
            // panel.
            if (!checkFilter() &&
                isConfigLoaded.value &&
                config.value.toolbox_auto_sort === true &&
                props.sortItems === true &&
                !elems.value.some((el) => el.text !== undefined && el.text !== "")) {
                const elements = [...elems.value];
                const sorted = elements.sort((a, b) => {
                    const aNameLower = a.name.toLowerCase();
                    const bNameLower = b.name.toLowerCase();
                    if (aNameLower > bNameLower) {
                        return 1;
                    }
                    else if (aNameLower < bNameLower) {
                        return -1;
                    }
                    else {
                        return 0;
                    }
                });
                return Object.entries(sorted);
            }
            else {
                return Object.entries(elems.value);
            }
        });
        watch(() => props.queryFilter, () => {
            opened.value = checkFilter();
        });
        watch(() => opened.value, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                const currentState = newVal ? "opened" : "closed";
                ariaAlert(`${name.value} tools menu ${currentState}`);
            }
        });
        onMounted(() => {
            eventBus.on(openToolSection);
        });
        onUnmounted(() => {
            eventBus.off(openToolSection);
        });
        function openToolSection(sectionId) {
            if (isSection.value && sectionId == props.category?.id) {
                toggleMenu(true);
            }
        }
        function checkFilter() {
            return !props.disableFilter && !!props.queryFilter;
        }
        function onClick(tool, evt) {
            emit("onClick", tool, evt);
        }
        function onOperation(tool, evt) {
            emit("onOperation", tool, evt);
        }
        function toggleMenu(nextState = !opened.value) {
            opened.value = nextState;
        }
        return { __sfc: true, emit, eventBus, props, config, isConfigLoaded, toolStore, elems, toolSection, toolSectionLabel, name, isSection, hasElements, title, links, opened, sortedElements, openToolSection, checkFilter, onClick, onOperation, toggleMenu, faFilter, FontAwesomeIcon, Tool, ToolPanelLabel, ToolPanelLinks };
    }
});
